/**
 * @Author:      jiang.weiwei
 * @DateTime:    2017-12-12 17:19:48
 * @Description: 角色设置
 */
"use strict";
angular.module("roleSettingModule", []).
controller("roleSettingCtrl", ["$scope", "$modalInstance", "httpService", "userId", function($scope, $modalInstance, httpService, userId) {
    initStatus();
    initData();

    function initStatus() {
        $scope.status = {
            switch: 'picture',
            leftSelected: [],
            rightSelected: []
        };
        $scope.data = {
            notExitsRole: [],
            exitsRole: [],
            selectedLeftArray: [], //左边选中的数据
            selectedRightArray: [] //右边选中的数据
        };
    }
    /**
     * [dblSelect description] 双击选择
     * @param {object} [item] [description] 所选角色
     * @return {[type]} [description]
     */
    $scope.dblSelect = function(item) {
        $scope.data.selectedLeftArray = [item.id];
        $scope.chooseToRight();
    };
    /**
     * [dblCancel description] 双击撤销
     * @param  {[type]} item [description] 所选角色
     * @return {[type]}      [description]
     */
    $scope.dblCancel = function(item) {
        $scope.data.selectedRightArray = [item.id];
        $scope.chooseToLeft();
    };
    /**
     * [chooseAll description] 全选
     * @return {[type]} [description]
     */
    $scope.chooseAll = function() {
        $scope.data.exitsRole = $scope.data.notExitsRole.concat($scope.data.exitsRole);
        $scope.data.notExitsRole = [];
        $scope.status.leftSelected = [];
    };
    /**
     * [cancelAll description] 撤销全部
     * @return {[type]} [description]
     */
    $scope.cancelAll = function() {
        $scope.data.notExitsRole = $scope.data.exitsRole.concat($scope.data.notExitsRole);
        $scope.data.exitsRole = [];
        $scope.status.rightSelected = [];
    };
    /**
     * [chooseToRight description] 选择
     * @return {[type]} [description]
     */
    $scope.chooseToRight = function() {
        var l = $scope.data.selectedLeftArray;
        var n = $scope.data.notExitsRole;
        var e = $scope.data.exitsRole;
        for (var i = 0; i < l.length; i++) {
            var id = l[i];
            for (var j = n.length - 1; j >= 0; j--) {
                var obj = n[j];
                if (id == obj.id) {
                    e.unshift(obj);
                    n.splice(j, 1);
                }
            }
        }
        $scope.data.selectedLeftArray = [];
    };

    /**
     * [chooseToLeft description] 撤销
     * @return {[type]} [description]
     */
    $scope.chooseToLeft = function() {
        var r = $scope.data.selectedRightArray;
        var e = $scope.data.exitsRole;
        var n = $scope.data.notExitsRole
        for (var i = 0; i < r.length; i++) {
            var id = r[i];
            for (var j = e.length - 1; j >= 0; j--) {
                var obj = e[j];
                if (id == obj.id) {
                    n.unshift(obj);
                    e.splice(j, 1);
                }
            }
        }
        $scope.data.selectedRightArray = [];
    };
    /**
     * [leftSelectNodes description] 左侧选中
     * @param {object} [item] [description] 所选项
     * @return {[type]} [description]
     */
    $scope.leftSelectNodes = function(item) {
        var index = $scope.data.selectedLeftArray.indexOf(item.id);
        index > -1 ? $scope.data.selectedLeftArray.splice(index, 1) : $scope.data.selectedLeftArray.push(item.id);
    };
    /**
     * [rightSelectNodes description] 右侧选中
     * @return {[type]} [description]
     */
    $scope.rightSelectNodes = function(item) {
        var index = $scope.data.selectedRightArray.indexOf(item.id);
        index > -1 ? $scope.data.selectedRightArray.splice(index, 1) : $scope.data.selectedRightArray.push(item.id);
    };

    function initData() {
        requestData();
    }

    $scope.confirm = function() {
        var ids = angular.packageIds($scope.data.exitsRole, ",", "id");
        $modalInstance.close(ids);
    };
    $scope.cancel = function() {
        $modalInstance.dismiss();
    };

    function requestData() {
        $scope.loadingPromise = httpService.http("/mcnadmin/admin/role/findRoleByUser.do", { userId: userId }, "post").then(function(data) {
        	
            $scope.data.notExitsRole = data.notExitsRole;
            $scope.data.exitsRole = data.exitsRole;
        });
    }
}]);